import { AuditoriaDetailsResponse } from "../typings";
import http from "infra/http"; 
import { useQuery } from "react-query";

export function useRelatorioAuditoria(id: string) {
  return useQuery(
    [`/v1/relatorios/auditoria/${id}`],
    async () => {
      const { data } = await http.get<AuditoriaDetailsResponse>(
        `/v1/relatorios/auditoria/${id}`
      );

      return data;
    },
  );
}
